module.exports = __webpack_public_path__ + "img/logo7.2a81eeb5.png";